import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PoIconModule } from '@po-ui/ng-components';

export interface StepBreadcrumbItem {
  label: string;
  icon?: string;
  id?: any;
}

@Component({
  selector: 'app-step-breadcrumb',
  imports: [PoIconModule, CommonModule],
  templateUrl: './step-breadcrumb.component.html',
  styleUrl: './step-breadcrumb.component.css'
})
export class StepBreadcrumbComponent {
  @Input() breadcrumbs: StepBreadcrumbItem[] = [];
  @Input() activeIndex: number = 0;
  @Input() canGoToNext: boolean = false;

  @Output() breadcrumbClick = new EventEmitter<{ item: StepBreadcrumbItem; index: number }>();

  onBreadcrumbClick(item: StepBreadcrumbItem, index: number) {
    const isGoingBack = index < this.activeIndex;
    const isGoingForward = index > this.activeIndex;

    if (isGoingBack || (isGoingForward && this.canGoToNext)) {
      this.breadcrumbClick.emit({ item, index });
    }
  }

  isClickable(index: number): boolean {
    if (index === this.activeIndex) return false;
    if (index < this.activeIndex) return true;
    return this.canGoToNext;
  }
}
